import React, { useState } from 'react';
import api from '../services/api';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from 'react-router-dom';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Card, CardBody, CardTitle } from 'reactstrap';
import { toast } from 'react-toastify';

const CreateVendor = () => {
  const [name, setName] = useState('');
  const [emailId, setEmailId] = useState('');
  const [address, setAddress] = useState('');
  const [mobileNo, setMobileNo] = useState('');
  const [gstin, setGstin] = useState('');
  const [year, setYear] = useState('');
  const [about, setAbout] = useState('');
  const [logoImageFile, setLogoImageFile] = useState(null);
  const [bannerFile, setBannerFile] = useState(null);
  const [open, setOpen] = useState('1');
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validateImageDimensions = (file, maxWidth, maxHeight) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => {
        if (image.width <= maxWidth && image.height <= maxHeight) {
          resolve(true);
        } else {
          resolve(false);
        }
      };
      image.onerror = () => {
        reject(new Error('Invalid image file.'))
      };
      image.src = URL.createObjectURL(file);
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let errors = {};

    if (!name.trim()) errors.name = 'Name cannot be empty';
    if (!emailId.trim()) { errors.emailId = 'email cannnot be empty' } else {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(emailId)) {
        errors.emailId = 'Please enter a valid email address';
      }
    };
    if (!mobileNo.trim()) { errors.mobileNo = 'mobile cannot be empty' } else {
      if (!/^[0-9]{10}$/.test(mobileNo)) {
        errors.mobileNo = 'Mobile number must be exactly 10 digits';
      }
    }
    if (!address.trim()) errors.address = 'address cannot be empty'
    if (!gstin.trim()) errors.gstin = 'gst_no cannot be empty'
    if (!year.trim()) errors.year = 'year cannot be empty'
    if (!about.trim()) errors.about = 'about cannot be empty'

    const allowedImageTypes = ['image/png', 'image/jpeg'];
    if (!logoImageFile) {
      errors.logoImageFile = 'logo image  cannot be empty, only PNG and JPG files are allowed';
    } else if (!allowedImageTypes.includes(logoImageFile.type)) {
      errors.logoImageFile = 'Only PNG and JPG files are allowed'
    } else {
      // const isValidImage = await validateImageDimensions(logoImageFile, 251, 168);
      // if (!isValidImage) {
      //   errors.logoImageFile = 'Package Image must be under 251px by 168px';
      // }
    }
    if (!bannerFile) {
      errors.bannerFile = 'banner image  cannot be empty, only PNG and JPG files are allowed';
    } else if (!allowedImageTypes.includes(bannerFile.type)) {
      errors.bannerFile = 'Only PNG and JPG files are allowed'
    } else {
      const isValidImage = await validateImageDimensions(bannerFile, 1342, 401);
      if (!isValidImage) {
        errors.bannerFile = 'banner image must be under 251px by 168px';
      }
    }

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    setErrors({});


    const formData = new FormData();
    formData.append('name', name);
    formData.append('address', address);
    formData.append('email_id', emailId);
    formData.append('mobileno', mobileNo);
    formData.append('emailid', emailId);
    formData.append('mobile_no', mobileNo);
    formData.append('gstin', gstin);
    formData.append('year', year);
    formData.append('about', about);
    formData.append('logo_image_path', logoImageFile);
    formData.append('banner_image_path', bannerFile);

    // console.log(formData)

    try {
      const response = await api.post('/vendor/add', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.data.status === "success") {
        toast.success(`Service Provider created successfully!`);
                          navigate('/manage-vendor', { replace: true });
      } else {
        toast.error(response.data || 'Failed to create Service Provider');
      }
    } catch (error) {
      toast.error(error.response?.data || 'Error creating Service Provider. Please try again later.');
      console.error('Error creating Service Provider:', error);
    }

  };

  const handleCancel = () => {
    setName('');
    setEmailId('');
    setMobileNo('');
    setGstin('');
    setYear('');
    setAbout('');
    setLogoImageFile(null);
    setBannerFile(null);
    navigate('/manage-vendor');
  };

  const toggle = (id) => {
    if (open === id) {
      setOpen("0");
    } else {
      setOpen(id);
    }
  };

  return (
    <div className='container mt-3 mb-5'>
      <CardTitle tag='h5' className='mb-3'>
        Service Provider List <span style={{ color: '#B0B0B0' }}>/ Add Service Provider</span>
      </CardTitle>
      <Card>
        <CardBody>
          <form onSubmit={handleSubmit}>
            <Accordion toggle={toggle} open={open}>
              <AccordionItem className='mb-4'>
                <AccordionHeader targetId='1'>Service Provider Details</AccordionHeader>
                <AccordionBody accordionId='1'>
                  <div className="col-xl-8">
                    <div className='mb-3'>
                      <label className="form-label">Name *</label>
                      <input type="text" className={`form-control ${errors.name ? 'is-invalid' : ''}`} value={name} onChange={(e) => setName(e.target.value)} placeholder="Enter Name" />
                      <b>{errors.name && <span className='text-danger small'>{errors.name}</span>}</b>
                    </div>
                    <div className='mb-3'>
                      <label className="form-label">Email ID *</label>
                      <input type="email" className={`form-control ${errors.emailId ? 'is-invalid' : ''}`} value={emailId} onChange={(e) => setEmailId(e.target.value)} placeholder="Enter Email" />
                      <b>{errors.emailId && <span className='text-danger small'>{errors.emailId}</span>}</b>
                    </div>
                    <div className='mb-3'>
                      <label className="form-label">Mobile No *</label>
                      <input type="tel" maxLength="10" value={mobileNo}
                        className={`form-control ${errors.mobileNo ? 'is-invalid' : ''}`}
                        onChange={(e) => setMobileNo(e.target.value)} placeholder="Enter Mobile No"
                      />
                      <b>{errors.mobileNo && <span className='text-danger small'>{errors.mobileNo}</span>}</b>
                    </div>
                    <div className='mb-3'>
                      <label className="form-label">Address *</label>
                      <input type="text" className={`form-control ${errors.address ? 'is-invalid' : ''}`} value={address} onChange={(e) => setAddress(e.target.value)} placeholder="Enter Address" />
                      <b>{errors.address && <span className='text-danger small'>{errors.address}</span>}</b>
                    </div>
                    <div className='mb-3'>
                      <label className="form-label">GSTIN *</label>
                      <input type="text" maxLength='15' value={gstin}
                        className={`form-control ${errors.gstin ? 'is-invalid' : ''}`}
                        onChange={(e) => setGstin(e.target.value)} placeholder="Enter GSTIN No"
                      />
                      <b>{errors.gstin && <span className='text-danger small'>{errors.gstin}</span>}</b>
                    </div>
                    <div className='mb-3'>
                      <label className="form-label">Year in Business *</label>
                      <input type="number" className={`form-control ${errors.year ? 'is-invalid' : ''}`} value={year} onChange={(e) => setYear(e.target.value)} placeholder="Enter Year in Business" />
                      <b>{errors.year && <span className='text-danger small'>{errors.year}</span>}</b>
                    </div>
                    <div className='mb-3'>
                      <label className="form-label">About Us *</label>
                      <ReactQuill value={about} onChange={setAbout} className='' placeholder="Enter Description" />
                      <b>{errors.about && <span className='text-danger small'>{errors.about}</span>}</b>
                    </div>
                  </div>
                </AccordionBody>
              </AccordionItem>

              <AccordionItem className='mb-4'>
                <AccordionHeader targetId='2'>Upload Image</AccordionHeader>
                <AccordionBody accordionId='2'>
                  <div className='col-xl-8'>
                    <div className='mb-3'>
                      <label className="form-label">Choose Logo Image * (only png and Jpg size 1342px*401px)</label>
                      <input type="file" className={`form-control ${errors.logoImageFile ? 'is-invalid' : ''}`} onChange={(e) => setLogoImageFile(e.target.files[0])} />
                      <b>{errors.logoImageFile && <span className="text-danger small">{errors.logoImageFile}</span>}</b>
                    </div>
                    <div className='mb-3'>
                      <label className="form-label">Choose Banner Image * (only png and Jpg size 186px*98px)</label>
                      <input type="file" className={`form-control ${errors.bannerFile ? 'is-invalid' : ''}`} onChange={(e) => setBannerFile(e.target.files[0])} />
                      <b>{errors.bannerFile && <span className='text-danger small'>{errors.bannerFile}</span>}</b>
                    </div>
                  </div>
                </AccordionBody>
              </AccordionItem>
              <div className="button-group">
                <button type="submit" className="btn btn-success submit-button"> Create </button>
                <button type="button" className="btn btn-danger cancel-button" onClick={handleCancel} > Cancel </button>
              </div>
            </Accordion>
          </form>
        </CardBody>
      </Card>

    </div>
  );
};

export default CreateVendor;
